__turbopack_context__.v({
  "actions": "styles-module-scss-module__irbAkW__actions",
  "agreeField": "styles-module-scss-module__irbAkW__agreeField",
  "button": "styles-module-scss-module__irbAkW__button",
  "checkbox": "styles-module-scss-module__irbAkW__checkbox",
  "half": "styles-module-scss-module__irbAkW__half",
  "input": "styles-module-scss-module__irbAkW__input",
  "label": "styles-module-scss-module__irbAkW__label",
  "recaptcha": "styles-module-scss-module__irbAkW__recaptcha",
  "root": "styles-module-scss-module__irbAkW__root",
  "validationText": "styles-module-scss-module__irbAkW__validationText",
});
